export default "__VITE_ASSET__CqYYErv9__"